import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import '@xterm/xterm/css/xterm.css';
import './styles.css';
import { initTelegramIntegration, getTelegramWebApp } from './lib/telegram';
import { App } from './App';

initTelegramIntegration();

const wa = getTelegramWebApp();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Theme
      appearance={wa?.colorScheme ?? 'dark'}
      accentColor="jade"
      grayColor="slate"
      radius="medium"
      scaling="100%"
    >
      <App />
    </Theme>
  </StrictMode>,
);
